module.exports = __webpack_public_path__ + "70ad3e23b4abbe20d7dbed0b8105883a.png";